import React from "react";
import { Link } from "react-router-dom";
import {
  Col,
  Container,
  ListGroup,
  Row,
} from "react-bootstrap";
import Fade from "react-awesome-reveal";


const AboutUs = (props) => {
  return (
    <>
      <Container style={{width: "1332px"}}>
        <Row className="common-styling">
          <Col xs="12" className="mb-4">
            <Fade direction="up">
              <h1>About us</h1>
            </Fade>
            <Fade direction="up">
              <p>
                Stud.com was built for internet entrepreneurs to build the right
                foundation from the start on high- end multi-million premium
                domains to reach their full potential. It's a platform for members
                who want to achieve any online business goals they set their minds
                to. It's a domain factory to help BIG IDEAS come to life and
                network with the best talent in the world. It's built to change
                the whole industry!
              </p>
            </Fade>
          </Col>
          <Col xs="12">
            <div className="how-it-works-card">
              <Fade direction="up">
                <h2 className="breed">
                  When you bring GREAT people together, GREAT things will happen
                </h2>
              </Fade>
              <Fade direction="up">
                <p>
                  All of the greatest companies had a legendary team to help them
                  get to the top. This is why our platform is always passionate to
                  match the top freelancers with Premium Domain Owners. When you
                  put certain ingredients together, EXPLOSIVE happen! Dynamite is
                  just how you put certain ingredients together to cause a
                  reaction. Those ingredients each sitting alone at a table mean
                  much less. Put them together in the right way and BOOM!
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Win-Win! Relationships are the currency of life. The better
                  relationships you have with your team to all grow together the
                  greater chance your business will have to succeed. When projects
                  are built on the prime domains it will open the doors of
                  victory. Steve Forbes one of the smartest people on the planet
                  told Rick Schwartz that domains are not “Commodities” because
                  they are UNIQUE!! They are “Collectibles”. They are “Virtual
                  Real Estate
                </p>
              </Fade><Fade direction="up">
                <h3>
                  Just think these companies worth hundreds of billions of dollars
                  and approaching Trillion Dollar Valuations, mostly work out of
                  ONE .com address.
                </h3>
              </Fade>
            </div>
          </Col>
          <Col xs="12" className="mt-5">
            <div className="how-it-works-card pb-5" id="ourmission">
              <Fade direction="up">
                <h2 style={{ color: "white" }}> OUR MISSION </h2>
              </Fade>
              <Fade direction="up">
                <p>
                  Our mission is to unleash a TIDAL WAVE of new business to
                  revolutionize the domain industry. Every level of our members
                  will have global opportunities to grow and change their destiny.
                  We want to change lives with lots of Rags to Riches stories!
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  The Riches get the Pitches who own the prime domain names giving
                  them the chance to find Creative geniuses to become partners or
                  expand their empire via the Startup Breeders
                </p>
              </Fade>
              <ListGroup className="my-4">
                <ListGroup.Item id="video-pitch-id">
                  <Fade direction="up">
                    <div className="video-pitch-strong">
                      <strong>Video Pitch Idea </strong> to always push the premium
                      domain to the limit so it gets the TRUE VALUE!
                    </div>
                  </Fade>
                </ListGroup.Item>
              </ListGroup>
              <Fade direction="up">
                <h3 style={{ lineHeight: "40px" }}>
                  No force on earth can stop true passion. <br></br>
                  No force on earth can hold you back
                </h3>
              </Fade>
              <Fade direction="up">
                <p>
                  We truly want all our members to succeed and be wildly
                  successful, connect VISIONARY LEADERS with like-minded people
                  who share their positive energy so the VOLCANO of VICTORY will
                  erupt and Magically things happen once you connect the dots. Our
                  mission is to take domains outta the dark into the LIGHT!
                  SPOTLIGHT!
                </p>
              </Fade>
            </div>
          </Col>

          <Col xs="12" className="mt-5">
            <div className="how-it-works-card">
              <Fade direction="up">
                <h2 className="breed">Turning Point</h2>
              </Fade>
              <Fade direction="up">
                <p>
                  OUR number one enemies are domain investors selling their assets
                  way too cheap. When it comes to valuation domainers are either
                  up in the ozone for worthless domains or they’re giving away
                  life-changing domains for less than life-changing amounts.
                  Sometimes even chump change. When will they ever learn??
                </p>
              </Fade>
              <Fade direction="up">
                <h3>THE DOMAIN SLEEPING DRAGON AWAKES</h3>
              </Fade>
              <Fade direction="up">
                <p>
                  Don’t come to Stud.com if you’re desperate and you need to sell
                  your domain TODAY for the lowest price. There are plenty of
                  venues that can do that for you and STUD is not one of them. We
                  don't need millions of names clogging up the system. Therefore,
                  we will set minimum values and quality to be listed.
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Join Stud because you are a founder of that domain name and
                  maybe you deserve more than just a one-time DESPERATE payday.
                  Come to Stud because you want to market and circulate your
                  domain name and have it utilized for the highest and best use.
                  Network on Stud for the right reasons, not the wrong reasons.
                  Members will join Stud to get the best results and help them
                  generate faster income with all our tools while waiting for the
                  BIG WHALE deal.
                </p>
              </Fade>
            </div>
          </Col>
          <Col xs="12" className="mt-5">
            <div className="how-it-works-card pb-5">
              <Fade direction="up">
                <h2 className="breed" style={{ color: "white" }}> OUR STORY </h2>
              </Fade>
              <Fade direction="up">
                <p>
                  Breeding Domain Names is always going to be the heart and soul
                  of our platform. We have an obsession to make great things
                  happen for premium domains. Our teams chemistry is magic and we
                  will continue to innovate so our members will always have a
                  Golden Standard platform. Stud was built with the labor of love
                  for the domain industry to make a domain factory with SUPER
                  TOOLS to change lives.
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  We will never be a wholesale market to get a quick buck. We
                  EMPOWER internet entrepreneurs with big ideas and always make
                  the domain the STAR. We believe partnerships can be formed
                  anywhere in the world once two parties come together to BUILD
                  YOUR DREAM.
                </p>
              </Fade><Fade direction="up">
                <p>
                  Stud was built after a Video Pitch Idea was sent to Rick
                  Schwartz. You too can do it! Show your entrepreneurial
                  endeavours to our members to create the next BIG THING.
                </p>
              </Fade>
              <Fade direction="up">
                <h3>They don't teach this is on the other platforms</h3>
              </Fade>
              <Fade direction="up">
                <p>
                  Most platforms are built so you are stuck in a SYSTEM of SHEEP
                  always heading down the RABBIT HOLE. We give you the TOOLS TO
                  RULE!
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Do you think the other platforms CARE about your best interests?
                  <br></br>
                  NO, because they have NO VISION what the domain could be, should
                  be, they have only used a landing page for years. If that's all
                  they can do with their company! Your domain has no chance. NO
                  CHANCE! All they have always EVER WANTED is a QUICK BUCK!!
                </p>
              </Fade>
              <Fade direction="up">
                <h3>
                  NEVER AGAIN!.. they don't deserve it! Domainers are being
                  treated like FOOLS!
                </h3>
              </Fade>
              <Fade direction="up">
                <p>
                  THEIR TIME IS UP! We are going to be like a PACK of WILD HORSES
                  all over them. STUD is the TURNING POINT for domainers and they
                  will have the GLORY giving them lots of business options they
                  have never had before! If you can't find a way they will make a
                  way on the GOLD STANDARD platform.
                </p>
              </Fade>
              <Fade direction="up">
                <h3>It's always going to be a One-Horse Race</h3>
              </Fade>
              <Fade direction="up">
                <p>
                  The way the platform is built is a MARKETING GENIUS SYSTEM full
                  of opportunities to chase your dream that’s always going to be
                  MILES AHEAD of the competition. We have created life-changing
                  tools, LIFE CHANGING TOOLS! It's going to be the MATCHMAKER to
                  the next GREATEST COMPANIES of the world all put together on
                  STUD.
                </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Stay tuned my friends.
                  <Link
                    style={{ color: "#ff5301" }}
                    target="_blank"
                    to="https://stud.com/"
                  >
                    STUD.com
                  </Link>
                  &nbsp;at your Service!
                </p>
              </Fade>
              <Fade direction="up">
                <p>Now some blunt talk. </p>
              </Fade>
              <Fade direction="up">
                <p>
                  Like you, we have aspirations. But we make NO PROMISES
                  WHATSOEVER. We have taken nearly 10 months to build something we
                  think will be useful. We have done it via a domain investors
                  perspective. We have shared our vision with you and now it is up
                  to YOU to use the tools we have made available and use them
                  wisely and to their fullest. We believe this can be a game
                  changer for investors and those with truly great domains. You
                  can't attract whales with bait made for minnows. What we do is
                  point out the difference. Together we think we can turn that
                  difference into life-changing opportunities. There is no
                  guarantee whatsoever as we start this journey together. So we
                  promise NOTHING but hope to give you EVERYTHING!{" "}
                </p>
              </Fade>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default AboutUs;
